import type { ReactNode } from "react";
import { View, Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";
import { sizes } from "@src/constants/sizes";

interface StatusCardContainerProps {
  title: string;
  children: ReactNode;
}

export function StatusCardContainer({ title, children }: StatusCardContainerProps) {
  const { theme } = useUnistyles();

  return (
    <View
      flex={1}
      minHeight={sizes.webCardHeight}
      bg="surfaceCard"
      borderRadius={theme.spacing.xl}
      borderWidth={1}
      borderColor="borderCard"
      p="5xl"
      gap="3xl"
    >
      <Text textStyle="sm/semibold" color="textMuted">
        {title}
      </Text>
      {children}
    </View>
  );
}
